import React from 'react';
import { Formik } from 'formik';
import Yup from 'yup';

import styles from './compensationSubmissionPageStyles.scss';

import CompensationSubmissionDrafts from './CompensationSubmissionDrafts/compensationSubmissionDrafts';
import CompensationSubmissionForm from './CompensationSubmissionForm/compensationSubmissionForm';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { userCompensationsUrl } from 'buyside/util/urlHelper';

const compensationSchema = Yup.object().shape({
  title: Yup.string().required('This field is required'),
  experience: Yup.string().required('This field is required'),
  industry: Yup.string().required('This field is required'),
  location: Yup.string().required('This field is required'),
  fundType: Yup.string().required('This field is required'),
  fundStrategy: Yup.string().required('This field is required'),
  fundSize: Yup.string().required('This field is required'),
  assetClass: Yup.string().required('This field is required'),
  baseSalary: Yup.string().required('This field is required')
});

const currentYear = new Date().getFullYear();

export const blankForm = {
  status: 'draft',
  year: currentYear - 1,
  category: 'actual',
  title: '',
  experience: '',
  industry: '',
  location: '',
  fundType: '',
  fundStrategy: '',
  fundSize: '',
  assetClass: '',
  baseSalary: '',
  interestMgmtFeesPerc: '',
  interestMgmtFeesValue: '',
  vestingMgmtFees: '',
  interestIncentiveFeesPerc: '',
  interestIncentiveFeesValue: '',
  vestingIncentiveFees: '',
  annualDiscrBonus: '',
  totalDeferredComp: '',
  investInFund: false,
  buildPersonalTrackRecord: false,
  marketPersonalTrackRecord: false,
  comments: '',
  mode: 'new'
};

class CompensationSubmissionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actualComp: null,
      pageNum: 1,
      headerCategory: 'Actual',
      headerYear: currentYear - 1
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(args, { resetForm }) {
    const { createCompensation, updateCompensation } = this.props;
    const variables = {
      status: args.status,
      year: args.year,
      category: args.category,
      title: args.title,
      experience: args.experience,
      industry: args.industry,
      location: args.location,
      fundType: args.fundType,
      fundStrategy: args.fundStrategy,
      fundSize: args.fundSize,
      assetClass: args.assetClass,
      baseSalary: Number(args.baseSalary),
      interestMgmtFeesPerc: Number(args.interestMgmtFeesPerc),
      interestMgmtFeesValue: Number(args.interestMgmtFeesValue),
      vestingMgmtFees: Number(args.vestingMgmtFees),
      interestIncentiveFeesPerc: Number(args.interestIncentiveFeesPerc),
      interestIncentiveFeesValue: Number(args.interestIncentiveFeesValue),
      vestingIncentiveFees: Number(args.vestingIncentiveFees),
      annualDiscrBonus: Number(args.annualDiscrBonus),
      totalDeferredComp: Number(args.totalDeferredComp),
      investInFund: args.investInFund || false,
      buildPersonalTrackRecord: args.buildPersonalTrackRecord || false,
      marketPersonalTrackRecord: args.marketPersonalTrackRecord || false,
      comments: args.comments
    };

    if (this.state.pageNum === 1) {
      createCompensation(variables).then(({ data }) => {
        const receivedData = data.createCompensation;
        this.setState({
          actualComp: receivedData.compensation,
          pageNum: 2,
          headerCategory: 'Estimated',
          headerYear: currentYear
        });
        blankForm.year = currentYear;
        blankForm.category = 'estimated';
        blankForm.actualComp = receivedData.compensation;
        resetForm(blankForm);
        window.scrollTo(0, 0);
      });
    } else if (this.state.pageNum === 2) {
      if (args.status === 'draft') {
        createCompensation(variables);
      } else if (args.status === 'published') {
        updateCompensation({ id: this.state.actualComp.id, status: 'published' });
        createCompensation(variables);
      }
      window.location.assign(userCompensationsUrl());
    }
  }

  render() {
    const { currentUser, currentUserLoading, userError, destroyCompensation } = this.props;

    if (userError) {
      if (userError.message.include('401')) {
        window.location.reload();
      }
      throw userError;
    }

    if (currentUserLoading) return <LoadingSpinner size="large" />;

    return (
      <div className={styles.container}>
        <div>
          {currentUser.draftCompensations.length > 0 && (
            <CompensationSubmissionDrafts
              currentUser={currentUser}
              destroyCompensation={destroyCompensation}
            />
          )}
        </div>
        <h3 className={styles.header}>
          {this.state.pageNum}. Enter {this.state.headerCategory} Compensation for{' '}
          {this.state.headerYear}
        </h3>
        <p className={styles.italicText}>
          *Please submit <strong>both</strong> your actual compensation for {currentYear - 1} and
          your estimated compensation for {currentYear}.
        </p>

        <Formik
          initialValues={blankForm}
          component={CompensationSubmissionForm}
          onSubmit={this.handleSubmit}
          validationSchema={compensationSchema}
        />
      </div>
    );
  }
}

export default CompensationSubmissionPage;
